export default {
    jp: {
        LP: {
            // 言語切り替えボタン
            change_locale: 'English',


            // OGP用情報
            ogp: {
                title: '',
                description: '',
                type: 'website',
                url: '',
                site_name: '',
                image: '/Images/Ogp/OGP.jpg',
                twitter_card: 'summary_large_image'
            },

            // INTRO
            intro: {
                headering: '#KEIKYUXR #京急XR' +
                    '\r\n' +
                    '#nakedinc #ネイキッドインク',
                lead_sp: 'KEIKYU OPEN TOP BUS YOKOHAMA -NAKED XR TOUR-は、横浜市のみなとみらいを舞台に、これまで類を見ない街を広域に楽しむインタラクティブなエンターテイメント体験です。' +
                    '\r\n' +
                    'クリエイティブカンパニーNAKED, INC.”ネイキッド”が贈る、観光×アートの新しい体験で皆様を歓迎いたします。',
                lead_pc: 'KEIKYU OPEN TOP BUS YOKOHAMA -NAKED XR TOUR-は、横浜市のみなとみらいを舞台に、これまで類を見ない街を広域に楽しむインタラクティブなエンターテイメント体験です。' +
                    '\r\n' +
                    'クリエイティブカンパニーNAKED, INC.”ネイキッド”が贈る、観光×アートの新しい体験で皆様を歓迎いたします。' +
                    '\r\n' +
                    '',

            },

            // About
            about: {
                caption_sp: '本バスツアーは、VRゴーグルを装着しながら、屋根がなく開放的な空間をご提供する「KEIKYU OPEN TOP BUS横浜」にて横浜・みなとみらいエリアを周遊、また最新のXR技術、HMD（ヘッドマウントディスプレイ）、センサー等を用いた世界で初めての観光体験をご提案するバスツアーです。',
                caption_pc: '本バスツアーは、VRゴーグルを装着しながら、屋根がなく開放的な空間をご提供する「KEIKYU OPEN TOP BUS横浜」にて横浜・みなとみらいエリアを周遊、また最新のXR技術、HMD（ヘッドマウントディスプレイ）、センサー等を用いた世界で初めての観光体験をご提案するバスツアーです。',
            },

            // Route Map
            route: {
                caption_sp: '物語の始まりは赤レンガ倉庫横浜のウォーターフロントを中心に6エリアを巡り、それぞれの街の魅力を発見することができ街そのものをアートとして捉える体験をお楽しみいただけます。',
                caption_pc: '物語の始まりは赤レンガ倉庫横浜のウォーターフロントを中心に6エリアを巡り、それぞれの街の魅力を発見することができ街そのものをアートとして捉える体験をお楽しみいただけます。',
                map: './Images/route_map.svg',
            },


            //新型コロナウイルス感染症対策について
            covid19: {
                title: '新型コロナウイルス感染症対策について',
                notice: '1回の乗車者数に制限がございます',
                caption: '人数制限のため、チケットの販売枚数を制限しています。' +
                    '\r\n' +
                    '前売りチケットのご購入をおすすめいたします。',
                detail: '詳細はこちら',
                spec: '以下の条件に当てはまる方はご来場をお断りしております。',
                subtitle: 'ご来場のみなさまへお願い',
                closing: '当面の間、大変ご不便をおかけしますが、皆様に安心してお楽しみいただくために、ご理解、ご協力のほど、何卒よろしくお願い申し上げます。',
            },
            covid19_guide1: [{
                    thumbnail: './Images/covid/corona_pic_01_black.svg',
                    description: '乗車時の検温で37.5℃以上の発熱がある方',
                },
                {
                    thumbnail: './Images/covid/corona_pic_02_black.svg',
                    description: '発熱・倦怠感など、体調がすぐれない方',
                },

            ],
            covid19_guide2: [{
                    thumbnail: './Images/covid/corona_pic_06_black.svg',
                    description: '乗車の際はマスクの着用をし、咳エチケットにご協力ください。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_05_black.svg',
                    description: '乗車時、消毒液で手指の消毒をお願いします。入場後にもアルコール除菌アートを設置しております。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_03_black.svg',
                    description: '車内でのソーシャルディスタンスの確保をお願いします。',
                },
                {
                    thumbnail: './Images/covid/corona_pic_04_black.svg',
                    description: 'マスクを外される際は、なるべく他の人との距離を保ち、大声での会話はご遠慮ください。',
                },
            ],


            // CONTENTS
            contents: {
                summary: 'ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。ここに説明が入ります。',
            },
            contents1: {
                image: './Images/contents/s1_prologue.jpg',
                title: 'S1 Prologue',
                title_sub: 'あればサブタイトル',
                caption: '未来のみなとみらいを観光する乗り物に乗って出発。',
                more: 'さらに詳しく',
                more_text: '未来のみなとみらいを観光する乗り物に乗って出発。',
                close: '閉じる',
            },

            contents2: {
                image: './Images/contents/s2_future.jpg',
                title: 'S2 Future City',
                title_sub: 'あればサブタイトル',
                caption: '現実の世界とバーチャルの世界が融合した未来都市。未来の観光を疑似体験する。',
                more: 'さらに詳しく',
                more_text: '現実の世界とバーチャルの世界が融合した未来都市。未来の観光を疑似体験する。',
                close: '閉じる',
            },

            contents3: {
                image: './Images/contents/futurepark_s.jpg',
                title: 'S3 Future Park',
                title_sub: 'あればサブタイトル',
                caption: '空飛ぶ遊具などが賑わう未来のテーマパーク。アトラクションに乗っているような感覚で進んでいく。',
                more: 'さらに詳しく',
                more_text: '空飛ぶ遊具などが賑わう未来のテーマパーク。アトラクションに乗っているような感覚で進んでいく。',
                close: '閉じる',
            },

            contents4: {
                image: './Images/contents/oceanworld_s.jpg',
                title: 'S4 Ocean World',
                title_sub: 'あればサブタイトル',
                caption: '優雅に泳ぐ海中生物とともに海中都市の世界へ。色鮮やかな珊瑚が煌めき、魚たちとも触れ合える。',
                more: 'さらに詳しく',
                more_text: '優雅に泳ぐ海中生物とともに海中都市の世界へ。色鮮やかな珊瑚が煌めき、魚たちとも触れ合える。',
                close: '閉じる',
            },

            contents5: {
                image: './Images/contents/augmentedworld_s.jpg',
                title: 'S5 Augmented World',
                title_sub: 'あればサブタイトル',
                caption: '全てが混ざり合う拡張された世界。未来への希望を示す、光が集結する。',
                more: 'さらに詳しく',
                more_text: '全てが混ざり合う拡張された世界。未来への希望を示す、光が集結する。',
                close: '閉じる',
            },

            contents6: {
                image: './Images/contents/epilogue.jpg',
                title: 'S6 Epilogue',
                title_sub: 'あればサブタイトル',
                caption: '再び時空のトンネルトンネルを通り、現実のみなとみらいへと戻ってくる。',
                more: 'さらに詳しく',
                more_text: '再び時空のトンネルトンネルを通り、現実のみなとみらいへと戻ってくる。',
                close: '閉じる',
            },

            //APP
            app: {
                ar_image: './Images/app/sample-app.jpg',
                vr_image: './Images/app/sample-app.jpg',
                inc_play: './Images/app/Naked-Inc_Play.jpg',
                google: './Images/app/google-play.png',
                google_link: 'https://play.google.com/store/apps/details?id=jp.co.naked.app02',
                apple: './Images/app/apple-app.png',
                apple_link: 'https://apps.apple.com/jp/app/naked-inc-play/id1534676228',
            },

            //ARTIST
            artist: {
                image: './Images/sample-artist.jpg',
                job: 'テキストテキスト',
                name: 'テキストテキスト',
                caption: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
            },

            // TICKETS
            tickets: {
                tickets_1: '4,000円（大人・子ども共通）',
                button: 'チケット購入はこちら',
            },

            // OUTLINE
            outline: {
                name: '名称',
                name_text: 'KEIKYU OPEN TOP BUS YOKOHAMA -NAKED XR TOUR-',
                term: '期間',
                term_text: 'COMING SOON',
                time: '催行時間',
                time_text: 'COMING SOON',
                place: 'ルート',
                place_text: '赤レンガ倉庫発着　横浜みなとみらいエリアを周遊',
                price: '入場料金',
                price_text: '詳しくはこちら',
                price_link: '',
                contact: 'お問い合わせ',
                contact_text: 
                    '株式会社京急アドエンタープライズ\r\n' +
                    'ビジネスサポート事業部\r\n' +
                    'TEL045-307-3855（9:30～18:00）\r\n' +
                    '※土日祝祭日、年末年始を除く\r\n' +
                    '\r\n'+
                    '旅行企画・実施\r\n' +
                    '観光庁長官登録旅行業第2020号\r\n' +
                    '株式会社京急アドエンタープライズ\r\n' +
                    'ビジネスサポート事業部総合旅行業務取扱管理者\r\n'+
                    '石田　淳一',
                terms: '※旅行業約款はこちら',
                terms_url: 'https://www.keikyu-ad.co.jp/business/pdf/yakkan01.pdf',
                conditions: '※旅行条件書はこちら',
                conditions_url: 'https://drive.google.com/file/d/144-MlDzRl-JYj6sDVUhrYeMBbyTSqra3/view?usp=sharing',
                operating: '運行会社\r\n'+
                '東洋観光株式会社',
            },

            // ACCESS
            access: {
                map: './Images/google_map.jpg',
                link: 'https://www.google.com/maps/place/%E8%B5%A4%E3%83%AC%E3%83%B3%E3%82%AC%E5%80%89%E5%BA%AB%E3%83%BB%E3%83%9E%E3%83%AA%E3%83%B3%EF%BC%86%E3%82%A6%E3%82%A9%E3%83%BC%E3%82%AF/@35.4529379,139.642332,19.9z/data=!4m5!3m4!1s0x60185c57c5e08b2d:0x3bd31581a403636d!8m2!3d35.4529458!4d139.6423077?hl=ja',
                caption: 'テキストテキストテキストテキストテキストテキストテキストテキストテキスト',
                parking: '駐車場',
                parking_button: '詳細はこちら',
                train_dt: '｜公共交通機関（電車)',
                train_dd: 'みなとみらい線「馬車道駅」または「日本大通り駅」より徒歩約6分\r\n' +
                    'みなとみらい線「みなとみらい駅」より徒歩約12分\r\n' +
                    'JR「桜木町駅」より汽車道経由で徒歩約15分\r\n' +
                    'JR「関内駅」より徒歩約15分',

                bus_dt: '｜公共交通機関（バス）',
                bus_dd: '観光スポット周遊バス「あかいくつ」\r\n' +
                    '（横浜市交通局）\r\n' +
                    '「桜木町駅前」から「赤レンガ倉庫・マリン＆ウォーク」下車\r\n' +
                    '「港の見える丘公園前」から「赤レンガ倉庫前」下車\r\n' +
                    '運賃：大人 220円 （小人 110円）\r\n' +
                    '連結バス「BAYSIDE BLUE」\r\n' +
                    '（横浜市交通局）\r\n' +
                    '「横浜駅前[東口バスターミナル]」から「カップヌードルパーク・ハンマーヘッド入口」下車\r\n' +
                    '「山下ふ頭」から「赤レンガ倉庫前」下車\r\n' +
                    '運賃：大人 220円 （小人 110円）\r\n' +
                    '京浜急行バス\r\n' +
                    '空港リムジンバス「羽田空港」から「赤レンガ倉庫」下車\r\n' +
                    '運賃：大人 720円（小人 360円）',

                car_dt: '｜お車（駐車場）',
                car_dd: 'ご利用時間： 24時間 / 年中無休\r\n' +
                    '駐車料金： 最初の1時間500円 以後250円/30分\r\n' +
                    '収容台数： P1・83台　P2・96台',

            },

            //CREDIT
            credit: {
                organizer: '主催',
                support: '技術協力',
                support_text: '',
                direction: '監修',
                technical: '技術提供',
                project: '企画・演出・制作',
                prj_1: '',
                caption: '1997年、村松亮太郎がディレクターやデザイナー、ライターとともに設立したクリエイティブカンパニー。“Core Creative” “Total Creation” “Borderless Creativity”を理念に、映画やTV、MV、広告、空間演出、地方創生、教育プログラムなどジャンルを超えた活動を手がける。総合プロデュースを手がけている食×アートの体験型レストラン「TREE by NAKED yoyogi park」も2017年東京にオープン。カルチャー、アート、エンターテインメント、伝統、教育、音楽、都市、食、スポーツなど、LIFE(生活)のあらゆる分野において心揺さぶるSCENE、新たな体験や価値を生み出している。',
            },

            buy_tickets: 'チケット購入',

        }


    },

}